<div class="search-bar-container">
    <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
            type="text"
            pInputText
            [formControl]="searchControl"
            (keyup)="onKeyPress($event)"
            [placeholder]="placeholder"
            class="cv-queue-searchbar"
        />
    </span>
</div>
